import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.baseContainerUrl + '/api/v1/'

export const getImages = (params) => {
  return axios.request({
    url: baseUrl + 'image/',
    params: params,
    method: 'get',
    paramsSerializer: function (params) {
      return require('qs').stringify(params, { indices: false })
    }
  })
}

export const getAllImages = (nodeId) => {
  return axios.request({
    url: baseUrl + 'image/all/',
    params: {node: nodeId},
    method: 'get'
  })
}

export const getImagePullTasks = (params) => {
  return axios.request({
    url: baseUrl + 'image/pull_task/',
    params: params,
    method: 'get',
    paramsSerializer: function (params) {
      return require('qs').stringify(params, { indices: false })
    }
  })
}

export const deleteImage = (id, nodeId) => {
  return axios.request({
    url: baseUrl + 'image_remove/' + id + '/',
    data: {node: nodeId},
    method: 'delete'
  })
}

export const batchDeleteImage = (images) => {
  return axios.request({
    url: baseUrl + 'image_remove/batch/',
    data: {images: images},
    method: 'delete'
  })
}

export const pullImage = (data) => {
  return axios.request({
    url: baseUrl + 'image/pull/',
    data: data,
    method: 'post'
  })
}
